import selfClient from "lib/CommonApi/selfClient";
import ProjectUtils from "common/projectUtils";
import {Location} from "history";

/**
 * dhbyun
 * Self App No.38 inquiryStaticData
 *
 * @param label
 * @param location
 */
export async function inquiryStaticData(label: string, location: Location<LocationState>) {
  return selfClient.post(`/api/common/inquiryStaticData`, {
    ...location.state.query,
    label: label,
    deviceType: ProjectUtils.convertCardDeviceTypeToSelf(location.state.query.deviceType),
    language: location.state.query.languageCode,
  }).then(res => res).catch(error => error);
}

/**
 * dhbyun
 * Self App No.59 inquiryFunctionAppVersion
 *
 * @param key
 * @param location
 */
export async function inquiryFunctionAppVersion(key: string, location: Location<LocationState>) {
  return selfClient.get(`/api/common/inquiryFunctionAppVersion`, {
    params: {
      key: key,
      deviceType: ProjectUtils.convertCardDeviceTypeToSelf(location.state.query.deviceType),
      language: location.state.query.languageCode,
      version: location.state.query.apiVersion
    }
  }).then(res => res).catch(error => error);
}